export function useOrganization() {
  const currentOrganization = useState<
    components['schemas']['Organization'] | null
  >('currentOrganization', () => null)
  const organizationCounts = useState<
    components['schemas']['OrganizationCounts'] | null
  >('organizationCounts', () => null)

  const clearOrganization = () => {
    currentOrganization.value = null
  }

  const setCounts = async () => {
    if (!currentOrganization.value) return

    const { $api } = useNuxtApp()
    await $api<components['schemas']['OrganizationCounts']>(
      `/organizations/${currentOrganization.value.id}/counts/`
    ).then((response) => (organizationCounts.value = response))
  }

  const refreshOrganization = async () => {
    if (!currentOrganization.value) return

    const { $api } = useNuxtApp()
    await $api<components['schemas']['Organization']>(
      `/organizations/${currentOrganization.value.id}/`
    ).then((response) => (currentOrganization.value = response))
  }

  const setOrganization = (
    organization?: components['schemas']['Organization']
  ) => {
    if (!organization) return

    currentOrganization.value = organization
  }

  return {
    clearOrganization,
    currentOrganization,
    setCounts,
    organizationCounts,
    refreshOrganization,
    setOrganization,
  }
}
